
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import Step from './Step.vue';
import Attachment from './Attachment.vue';
import FileTable from '../feedbackForm/FileTable.vue';
import moment from 'moment';
import * as util from '../conf';

@Component({
  components: {
    Step,
    Attachment,
    FileTable
  }
})
export default class FormInfo extends Vue {
  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;  
  };
  url:string='https://jira.mingyuanyun.com/browse/';
  desc:string='';
  @Prop() formLabel: any;
  @Prop() formData: any;
  @Prop() TypeEnum: any;
  @Prop({ default: false }) canEdit: boolean;
  @Prop({ default: false }) canTrans: boolean;

  @Getter productSubsystemList: any;
  @Getter allproductSubsystemList: any;
  @Getter productModuleList: any;
  @Getter productEditionList: any;
  @Getter assignee: any;
  @Getter defaultAssignee: any;
  @Getter defaultAssigneeByModule: any; // 模块默认经办人信息

  @Action getAssignee: Function;
  @Action getDefaultAssignee: Function;
  @Action getProductSubsystemList: Function;
  @Action getAllProductSubsystemList :Function;
  @Action getProductModuleList: Function;
  @Action getProductEditionList: Function;
  @Action('getDefaultAssigneeByModule') getDefaultAssigneeByModule: Function;
  // 表单数据
  form: any = {
    FeedbackDescribe: '',
    FileUpload: '',
    deleteFileUpload: ''
  };
  transForm: any = {
    SubSystemName: '',
    SubSystemGUID: '',
    ModuleName: '',
    ModuleGUID: '',
    EditionName: '',
    EditionGUID: '',
    assignee: { name: '',displayname:'' }
  };

  isInited: boolean = false;

  confirmFileList(fileList: any[]) {
    this.form.FileUpload = JSON.stringify(fileList);
  }
  deleteFileList(fileList: any[]) {    
    
    this.form.deleteFileUpload = JSON.stringify(fileList);
  }
  created() {
    this.getAssignee();
    this.getDefaultAssignee();
    this.getProductSubsystemList();
    this.getAllProductSubsystemList();
    this.transForm.BUName = util.getUserBUName();
    // this.transForm.BUName = '武汉研发中心';  
    // 设置当前状态herf:
    if(process.env.NODE_ENV=='development'||process.env.NODE_ENV=='test'){
        this.url= 'http://10.5.11.226:8080/browse/';  
    } 
    // 设置描述默认提示语
    if(this.TypeEnum==1){
      this.desc='请至少提供业务场景、以及你对问题的理解。';
    }else if(this.TypeEnum==2){
      this.desc='请至少提供业务场景，用户痛点以及期望结果。';
    }else if(this.TypeEnum==3){
      this.desc='请至少提供问题重现步骤、期望结果以及实际结果。';
    }
  }
  mounted() {
    this.setEditForm();
  }

  updated() {    
    this.setEditForm();
  }
  @Watch('canTrans')
  watchBasicInfoCanTrans(newVal: boolean, oldVal: boolean) {
    const subsystem = this.allproductSubsystemList.data.find(
    //const subsystem = this.productSubsystemList.data.find(
      (item: any) => item.SubSystemGUID === this.formData.SubSystemGUID
    );
    // 如果可以编辑 并且不是被禁用数据，赋值  否则 情况选项
    if (this.canTrans&&subsystem) {
      this.transForm.SubSystemGUID = this.formData.SubSystemGUID;
      this.changeSubsystem(this.transForm.SubSystemGUID);
      this.transForm.EditionGUID = this.formData.EditionGUID;
      this.transForm.EditionName = this.formData.EditionName;
      this.transForm.ModuleGUID = this.formData.ModuleGUID;
      this.transForm.ModuleName = this.formData.ModuleName;
    } else {
      this.transForm = {
        SubSystemName: '',
        SubSystemGUID: '',
        ModuleName: '',
        ModuleGUID: '',
        EditionName: '',
        EditionGUID: '',
        assignee: { name: '' }
      };
    }
  }
  setEditForm() {
    if (this.isInited) return;
    if (this.canEdit && this.formData) {
      if (this.formData.FeedbackDescribe) {
        this.form.FeedbackDescribe = this.formData.FeedbackDescribe;
      }
      if (this.$refs.filetable) {
        this.$refs.filetable[0].setDefaultFileList(
          this.formData.FileUpload ? JSON.parse(this.formData.FileUpload) : []
        );
      }
      this.isInited = true;
    }
  }

  submmitForm() {
    if (this.canEdit) {
      return this.form;
    }
  }

  submitTransform() {
    if (this.canTrans) {
      return this.transForm;
    }
  }

  // 获取对应的状态名称
  getStatusEnum(type: number) {
    let statusEnum = '';
    switch (type) {
      case 1:
        statusEnum = '待处理';
        break;
      case 2:
        statusEnum = '处理中';
        break;
      case 3:
        statusEnum = '已关闭';
        break;
      case 4:
        statusEnum = '规划中';
        break;
      case 5:
        statusEnum = '已兑现';
        break;                
    }

    return statusEnum;
  }

  getTypeEnum(type: number) {
    // 1:产品咨询;2:产品建议;3:产品BUG
    switch (type) {
      case 1:
        return '产品咨询';
      case 2:
        return '产品建议';
      case 3:
        return '产品BUG';
      default:
        return '--';
    }
  }

  getLabelContent(key: string, val: any) {
    // else if (key === 'Workload') {
    //     return this.getWorkload(val);
    // }
    if (key === 'StatusEnum') {
      return this.getStatusEnum(val);
    } else if (key === 'TypeEnum') {
      return this.getTypeEnum(val);
    } else if (key === 'JIRATypeEnum') {
      return this.getTypeEnum(val);
    } else if (val) {
      return val;
    } else if (key && !val) {
      return '--';
    } else {
      return '';
    }
  }

  isEmptyContent(val: any) {
    return !val;
  }

  // 时间转换
  setTime(time: string) {
    return time ? moment(time).format('YYYY-MM-DD') : '--';
  }

  // 获取工作量（天）
  getWorkload(val: string) {
    return val ? (Number(val) / (24 * 60 * 60)).toFixed(2) : '';
  }

  // 获取附件列表
  getAttachmentData(val: string) {
    return val ? JSON.parse(val) : [];
  }
  // 选择子系统
  changeSubsystem(key: any) {    
    this.setAssignee(key);
    this.transForm.ModuleGUID = '';
    this.transForm.EditionGUID = '';
    this.transForm.ModuleName = '';
    this.transForm.EditionName = '';
    const subsystem = this.allproductSubsystemList.data.find(
    // const subsystem = this.productSubsystemList.data.find(
      (item: any) => item.SubSystemGUID === key
    );
  
    if (subsystem) {
      this.transForm.SubSystemName = subsystem.SubSystemName;
      this.getProductModuleList({
        subSystemName: this.transForm.SubSystemName
      });
      this.getProductEditionList({
        subSystemName: this.transForm.SubSystemName
      });
      // 查找模块默认经办人信息
      this.getDefaultAssigneeByModule({
        subSystemName: subsystem.SubSystemName
      });      
    }
  }

  // 设置默认经办人
  setAssignee(sysid: any) {
    this.defaultAssignee.data.map((item: any) => {
      if (item.SubSystemGuid === sysid) {
        this.assignee.data.map((ass: any) => {
          if (ass.id === item.JiraUserId.toString()) {
            // this.newAss = ass;
            this.transForm.assignee.name = ass.name;    // 经办人账号
            this.transForm.assignee.displayname = ass.displayName;  // 经办人名称
          }
        });
      }
    });
  }
  // 选择模块
  changeModule(key: any) {
    const moduleInfo = this.productModuleList.data.find(
      (item: any) => item.ModuleGUID === key
    );
    this.transForm.ModuleName = moduleInfo.ModuleName;

    // 获取模块默认经办人 如果存在替换经办人字段，如果不存在 不替换
    var user = this.defaultAssigneeByModule.data.find((item:any) => item.ModuleGUID===key);
    if(user && user.JiraUserId != null){        
        this.assignee.data.map((ass:any)=>{
          if(ass.id === user.JiraUserId){
            this.transForm.assignee.name = ass.name;    // 经办人账号
            this.transForm.assignee.displayname = ass.displayName;  // 经办人名称
          }
        });
    }else if(user){
      // 如果模块没有设置默认经办人，默认经办人改为子系统默认经办人
      this.setAssignee(user.SubSystemGUID);
    }

  }

  // 选择子系统
  changeEdition(key: any) {
    const edition = this.productEditionList.data.find(
      (item: any) => item.EditionGUID === key
    );
    this.transForm.EditionName = edition.EditionName;
  }
  getText(val: string) {
    // return val ? val.replace(new RegExp('(\r\n)|(\n)', 'g'), '<br/>') : '--';
    return val ? val.replace(/\\r\\n/g, '<br/>') : '--';
  }
}
